import { pointsExtractConstants } from './points-extract.constants'

const initialState = {
	isSearching: false,
	searchedUser: {
		name: '',
		moveflexNumber: null,
		role: null,
		points: null,
		expiringPoints: null
	},
	options: []
}

function pointsExtractReducer(state = initialState, { type, payload }) {
	switch (type) {
		case pointsExtractConstants.SET_SEARCHED_USER:
			return { ...state, searchedUser: payload }

		case pointsExtractConstants.ADD_OPTIONS:
			return {
				...state,
				options: state.options.concat(payload).$unique()
			}

		default:
			return state
	}
}

export { pointsExtractReducer as Reducer }
